<div class="modal fade modal-full-width" #modal>
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Selecionar Participante da Central de Compras
                </h4>
                <h6 class="modal-subtitle mb-0" *ngIf="subtitle">
                    {{subtitle}}
                </h6>
            </div>
            <div class="modal-body">
                <ng-template [ngIf]="isLoadingCentralCompra">
                    <p class="text-muted">
                        <i class='fas fa-spinner fa-pulse'></i> Carregando central de compras
                    </p>
                </ng-template>
                
                <ng-template [ngIf]="isLoadedCentralCompra">
                    <div class="row">
                        <div class="form-group col-12">
                            <label class="col-form-label">Central de Compras</label>            
                            <input type="text" class="form-control" [value]="centralCompras?.nome" disabled="disabled" readonly="readonly">                           
                            <p class="form-text text-muted">
                                {{centralCompras?.nomeFantasia}}
                            </p>             
                        </div>
                    </div>

                    <sgt-cliente-central-compra-participante-select
                        [participantes]="centralCompras?.participantes"
                        (onSelectParticipante)="selectParticipante($event)">
                    </sgt-cliente-central-compra-participante-select>
                </ng-template>                
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancel()">
                    Cancelar
                </button>           
            </div>            
        </div>
    </div>
</div>